import React, {useCallback, useEffect, useState} from 'react';
import {Col, Layout, Row} from 'antd';
import {Outlet, useLocation} from "react-router-dom";
import ProHeader from "../components/ProHeader";
import ProFooter from "../components/ProFooter";

const {Content} = Layout;

function ProLayout() {
    return (
        <div>
            <ProHeader/>
            <Layout className="layout" style={{width: '100%'}}>
                <Content>
                    <Outlet/>
                </Content>
            </Layout>
            <ProFooter/>
        </div>
    );
}

export default ProLayout;